import { Box, Popper, TableCell, TextField, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useReducer, useRef } from 'react';

import { useTranslation } from '../../../packages/common/utils/getLocalString';

// Original class: tableCellMedium
const StyledTableCellMedium = styled(TableCell)(theme => ({
  boxShadow: '1px 1px #E4E4EF',
  width: 95,
}));
// Original class: tableFieldBox
const StyledTableFieldBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 0, 2, 2),
}));
// Original class: tableCellField
const StyledTableCellField = styled(TextField)(({ theme }) => ({
  position: 'relative',
  maxHeight: 20,

  '& .MuiInputBase-input, & .MuiOutlinedInput-notchedOutline': {
    width: '100%',
    height: 20,
    border: '0 !important',
    textAlign: 'right',
    padding: 0,
    marginRight: theme.spacing(8),
  },

  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    appearance: 'none',
  },

  '& input::placeholder': {
    color: '#7174AC',
  },
}));
// Original class: dayComment
const StyledDayComment = styled(Box)(theme => ({
  cursor: 'pointer',
}));
// Original class: commentTooltip
const StyledCommentTooltip = styled(Popper)(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    marginTop: '0 !important',
    backgroundColor: '#F1F2F8',
    borderRadius: theme.spacing(4),
    padding: theme.spacing(2),
    color: '#212346',
  },
}));

const SpreadsheetWeekValue = ({
  projectIssue,
  day,
  handleUpdateDayHourWithWeekUpdate,
  handleChangeDayComment,
  timeType,
}) => {
  const getLocalString = useTranslation();
  const defaultTimeSheetComment = getLocalString(
    'SpreadsheetContainer',
    'labels',
    'comments',
  );
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const handleChangeComment = useCallback(
    ({ currentTarget: target }) => {
      handleChangeDayComment(
        target.value,
        projectIssue.issueUniqueId,
        target.dataset.date,
        timeType,
      );
      return forceUpdate();
    },
    [handleChangeDayComment, projectIssue.issueUniqueId, timeType],
  );

  const { current: dayHourInputProps } = useRef({
    placeholder: '0',
    'data-date': day.date,
  });

  const { current: dayCommentInputProps } = useRef({
    'data-date': day.date,
  });

  return (
    <StyledTableCellMedium key={day.date} lign='right'>
      <StyledTableFieldBox
        sx={{ outline: day.isError ? '1px solid #E03737' : 'none' }}
      >
        <StyledTableCellField
          disabled={
            projectIssue.isClosed ||
            day.isApproved ||
            `${projectIssue.issueId}`.split('').includes('_')
          }
          type='text'
          name={timeType}
          value={day.hours !== 0 ? day.hours : ''}
          onChange={handleUpdateDayHourWithWeekUpdate}
          onWheel={e => {
            e.target.blur();
          }}
          slotProps={{
            htmlInput: dayHourInputProps,
          }}
        />
        <StyledDayComment>
          <Tooltip
            title={day.comments || ''}
            slotProps={{
              popper: { component: StyledCommentTooltip },
            }}
          >
            <StyledTableCellField
              disabled={
                projectIssue.isClosed ||
                day.isApproved ||
                `${projectIssue.issueId}`.split('').includes('_')
              }
              placeholder={defaultTimeSheetComment}
              value={day.comments}
              onChange={handleChangeComment}
              slotProps={{
                htmlInput: dayCommentInputProps,
              }}
            />
          </Tooltip>
        </StyledDayComment>
      </StyledTableFieldBox>
    </StyledTableCellMedium>
  );
};

export default SpreadsheetWeekValue;
